import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { isEmpty, cloneDeep } from 'lodash';
import moment from 'moment';
import PageTitle from '../../../../components/PageTitle';
import RouteNames from '../../../App/RouteNames';
import {
  uploadMultiPartFiles,
  getConfigUsagePlatforms,
  saveOutputTemplateByType,
  getOutputTemplateByType,
} from '../../../App/actions';
import TitleFrom from '../../../../components/common/TitleFrom';
import { EnergyTopupSearchForm } from '../../../../components/ReportHub';
import {
  SwitchExport,
  DataTable,
  ExcelExport,
  TablePagination,
  ButtonExport,
  EmailGroup,
  DragDropConfigExportTemplate,
  ModalWithItem,
} from '../../../../components/common';
import { tabelColumnExportEnergyTopup, sortEnergyTopup } from '../../constants';
import { getEnergyTopupReport, getAllEnergyTopupReport } from '../../actions';
import { makeGetEnergyTopupReport, makeGetListAllEnergyTopupReport } from '../../selectors';
import {
  getPageTotalCount,
  parseToMutationRequestPostMethod,
  blobToFile,
  validateEmail,
  blobToCSVFile,
  configOutputTemplateByType,
} from '../../../../utils/utils';
import convertJson2Sheet from '../../../../utils/ExcelHelper/exportExcelFile';
import convertJson2Pdf from '../../../../utils/PdfHelper/exportPdfFile';
import { PAGE_SIZE_DOWNLOAD } from '../../../../utils/constants';

let tableColumnsOutput = null;

class EnergyTopup extends Component {
  state = {
    isActivePdf: false,
    page: 0,
    size: 20,
    filter: {},
    sort: '',
    sorted: {},
    totalCount: null,
    isSearching: false,
    listEnergyTopup: [],
  };

  buttonRef = React.createRef();

  static getDerivedStateFromProps(props, state) {
    return {
      listEnergyTopup: props.listEnergyTopup,
      totalCount: getPageTotalCount({ ...state, items: props.listEnergyTopup }),
    };
  }

  componentDidMount() {
    const {
      permissions: { modeGetEnergyTopupReport },
    } = this.props;
    if (modeGetEnergyTopupReport) {
      this.doGetOutputTemplateByType();
      this.doGetListEnergyTopup();
    }
  }

  onSortColumn = (sortCol, sortDir) => {
    this.setState({ sorted: { sortCol, sortDir } }, () => {
      this.doGetListEnergyTopup();
    });
  };

  onPageChange = pageChange => {
    const { page } = this.state;
    if (page === pageChange) return '';
    return this.setState({ page: pageChange }, () => this.doGetListEnergyTopup());
  };

  onSizeChange = size => {
    this.setState({ size, page: 0 }, () => this.doGetListEnergyTopup());
  };

  onHandleSubmitSearch = filter => {
    this.setState({ filter: { ...filter }, page: 0 }, () => {
      this.doGetListEnergyTopup();
    });
  };

  doGetListEnergyTopup = () => {
    const { filter, page, size, sorted } = this.state;
    const { getEnergyTopupReport } = this.props;
    const newFilter = cloneDeep(filter);
    if (!newFilter.startDateTime) {
      newFilter.startDateTime = moment()
        .startOf('month')
        .format('YYYY-MM-DD');
    }

    const payload = {
      page: page + 1,
      size,
      filter: newFilter,
      sort:
        !isEmpty(sorted) && sortEnergyTopup[sorted.sortCol] ? sortEnergyTopup[sorted.sortCol][sorted.sortDir] : null,
    };
    this.setState({ isSearching: true });
    getEnergyTopupReport(payload, () => {
      this.setState({ isSearching: false });
    });
  };

  doGetAlllistEnergyTopup = cb => {
    const { filter, sorted } = this.state;
    const { getAllEnergyTopupReport } = this.props;
    const newFilter = cloneDeep(filter);

    if (!newFilter.startDateTime) {
      newFilter.startDateTime = moment()
        .startOf('month')
        .format('YYYY-MM-DD');
    }

    const payload = {
      page: 1,
      size: PAGE_SIZE_DOWNLOAD,
      filter: newFilter,
      sort: !isEmpty(sorted) ? sortEnergyTopup[sorted.sortCol][sorted.sortDir] : null,
    };
    getAllEnergyTopupReport(payload, () => {
      if (cb) cb();
    });
  };

  onChangeSwitch = () => {
    const { isActivePdf } = this.state;
    this.setState({ isActivePdf: !isActivePdf });
  };

  onExport = () => {
    this.doGetAlllistEnergyTopup(() => {
      const { isActivePdf } = this.state;
      if (isActivePdf) {
        const { listAllEnergyTopup, t } = this.props;
        convertJson2Pdf({
          data: listAllEnergyTopup,
          t,
          title: t('reportPage:sidebar.energyTopup').toLocaleUpperCase(),
          fileName: `${t('reportPage:sidebar.energyTopup')
            .toLocaleLowerCase()
            .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`,
          columnsTable: tableColumnsOutput,
        });
      } else {
        this.buttonRef.current.click();
      }
    });
  };

  sendEmail = ({ subject, emailBody }) => {
    this.doGetAlllistEnergyTopup(() => {
      const { listAllEnergyTopup, t, uploadMultiPartFiles } = this.props;
      const { emails, isActivePdf } = this.state;

      const query = `{"query": "mutation{sendReport(input: ${parseToMutationRequestPostMethod(
        {
          emailAddress: emails.join(', '),
          type: 'ENERGY_TOPUP_REPORT',
          subject: subject || `Embrix Report ${t('reportPage:sidebar.energyTopup')}`,
          emailBody,
        },
        ['type']
      )})}"}`;
      const formData = new FormData();

      if (!isActivePdf) {
        formData.append(
          'file',
          blobToCSVFile({
            fileName: `${t('reportPage:sidebar.energyTopup')
              .toLocaleLowerCase()
              .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}.csv`,
            data: listAllEnergyTopup,
            t,
            columns: tableColumnsOutput,
            listOptionFields: {
              serviceType: 'serviceType',
            },
          })
        );
      } else {
        const pdfFile = convertJson2Pdf({
          data: listAllEnergyTopup,
          t,
          title: t('reportPage:sidebar.energyTopup').toLocaleUpperCase(),
          fileName: `${t('reportPage:sidebar.energyTopup')
            .toLocaleLowerCase()
            .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`,
          isFile: true,
          columnsTable: tableColumnsOutput,
        });
        formData.append(
          'file',
          blobToFile(
            pdfFile,
            `${t('reportPage:sidebar.energyTopup')
              .toLocaleLowerCase()
              .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`
          )
        );
      }

      formData.append('graphql', query);
      // formData.append('file', blobToFile(pdfFile, 'attachment'));
      uploadMultiPartFiles(
        formData,
        res => {
          if (res && res.success) {
            if (res.success) this.setState({ emails: [] });
          }
        },
        true
      );
    });
  };

  onChangeEmail = tags => {
    let isEmail = true;
    if (tags && tags.length) {
      tags.forEach(email => {
        if (!validateEmail(email)) {
          isEmail = false;
        }
      });
    }
    if (!isEmail) return '';

    return this.setState({ emails: tags });
  };

  doGetOutputTemplateByType = () => {
    const { getOutputTemplateByType, t } = this.props;
    getOutputTemplateByType('ENERGY_TOPUP_REPORT', ({ success, data }) => {
      if (success && data) {
        this.setState({
          exportColumnsSave: configOutputTemplateByType({
            columns: tabelColumnExportEnergyTopup,
            data,
            t,
          }),
          idOutputTemplate: data?.id,
          typeOutputTemplate: data?.type,
        });
      }
    });
  };

  onHandleSaveConfig = columns => {
    const { saveOutputTemplateByType } = this.props;
    const { idOutputTemplate, typeOutputTemplate } = this.state;
    const payload = {
      id: idOutputTemplate,
      type: typeOutputTemplate,
      source: columns.sourceFields.items.map((val, index) => {
        return { name: val.name, index: index + 1 };
      }),
      target: columns.targetFields.items.map((val, index) => {
        return { name: val.name, index: index + 1 };
      }),
    };

    saveOutputTemplateByType(payload, ({ success }) => {
      if (success) {
        this.doGetOutputTemplateByType();
        this.setState({ exportColumnsSave: columns, isOpenModalExportConfig: false });
      }
    });
  };

  onToggleModalExportConfig = () => {
    const { isOpenModalExportConfig } = this.state;
    this.setState({ isOpenModalExportConfig: !isOpenModalExportConfig });
  };

  render() {
    const {
      isSearching,
      isActivePdf,
      sorted,
      page,
      size,
      totalCount,
      listEnergyTopup,
      emails,
      filter,
      exportColumnsSave,
      isOpenModalExportConfig,
    } = this.state;
    const {
      listAllEnergyTopup,
      t,
      permissions: { modeGetEnergyTopupReport, modeDownloadReport, modeGetMailReport },
    } = this.props;
    if (!modeGetEnergyTopupReport) return '';
    const exportColumns = exportColumnsSave || {};
    tableColumnsOutput = exportColumns?.targetFields?.items || [];
    return (
      <div className="col-md-12">
        <PageTitle
          linkTo={RouteNames.report.path}
          titleBtn="back"
          items={[
            { name: t('label.report'), url: RouteNames.report.path },
            { name: t('reportPage:sidebar.energyTopup') },
          ]}
        />
        <br />
        <div className="card card-statistics mb-30">
          <TitleFrom title={t('reportPage:sidebar.energyTopup')} />
          <div className="col-md-12 mb-30">
            <div className="card-body">
              <div className="pl-2">
                <EnergyTopupSearchForm onSubmit={this.onHandleSubmitSearch} defaultFilter={filter} />
              </div>
              <div>
                <div className="mt-3 col-md-12 row mb-4 pt-3 pb-3">
                  <button
                    type="submit"
                    onClick={this.onToggleModalExportConfig}
                    className="button x-small mr-2 btn-config"
                  >
                    {/* {t('label.outputConfig')} */}
                    <i className="ti-list" />
                  </button>
                  {!!modeDownloadReport && (
                    <div className="ml-auto mt-2 mb-auto mr-3">
                      <SwitchExport
                        onChange={this.onChangeSwitch}
                        wrapperClass={isActivePdf ? 'switch-active' : 'switch-non-active'}
                        title={t('label.excel')}
                        checked={isActivePdf}
                        rightTitle={t('label.pdf')}
                      />
                    </div>
                  )}
                  {!!modeDownloadReport && (
                    <>
                      <ButtonExport onExport={this.onExport} />
                      <ExcelExport
                        element={<button type="button" className="display-none" ref={this.buttonRef} />}
                        nameSheet={t('reportPage:sidebar.energyTopup').toLocaleUpperCase()}
                        multiDataSet={convertJson2Sheet({
                          data: listAllEnergyTopup,
                          t,
                          title: t('reportPage:sidebar.energyTopup').toLocaleUpperCase(),
                          columnsTable: tableColumnsOutput,
                        })}
                        fileName={`${t('reportPage:sidebar.energyTopup')
                          .toLocaleLowerCase()
                          .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`}
                      />
                    </>
                  )}
                  {modeGetMailReport !== 0 && (
                    <EmailGroup
                      emails={emails}
                      onChangeEmail={this.onChangeEmail}
                      sendEmail={this.sendEmail}
                      data={listEnergyTopup}
                    />
                  )}
                </div>
                <DataTable
                  columns={tableColumnsOutput}
                  data={listEnergyTopup && listEnergyTopup.length ? listEnergyTopup : []}
                  onSort={this.onSortColumn}
                  sorted={sorted}
                  isLoading={isSearching}
                  isFixedHeaderTable
                />
              </div>
            </div>
          </div>
        </div>
        <div className="mb-30">
          <TablePagination
            pageNumber={page}
            pageSize={size}
            totalCount={totalCount}
            onPageChange={this.onPageChange}
            onSizeChange={this.onSizeChange}
          />
        </div>
        <ModalWithItem
          onToggle={this.onToggleModalExportConfig}
          isOpen={isOpenModalExportConfig}
          wrapperClass="modal-config"
        >
          <div className="col-md-12 d-flex">
            <div className="column-config" onClick={this.onToggleModalExportConfig} />
            <div className="body-config">
              <DragDropConfigExportTemplate
                onHandleSave={this.onHandleSaveConfig}
                exportColumns={exportColumns}
                onToggle={this.onToggleModalExportConfig}
              />
            </div>
          </div>
        </ModalWithItem>
      </div>
    );
  }
}

EnergyTopup.propTypes = {
  getEnergyTopupReport: PropTypes.func,
  getAllEnergyTopupReport: PropTypes.func,
  listAllEnergyTopup: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.any), PropTypes.objectOf(PropTypes.any)]),
};

EnergyTopup.defaultProps = {
  getEnergyTopupReport: () => {},
  getAllEnergyTopupReport: () => {},
  listAllEnergyTopup: [],
};

const mapStateToProps = createStructuredSelector({
  listEnergyTopup: makeGetEnergyTopupReport() || [],
  listAllEnergyTopup: makeGetListAllEnergyTopupReport() || [],
});
export default withTranslation('common')(
  connect(mapStateToProps, {
    getEnergyTopupReport,
    getAllEnergyTopupReport,
    uploadMultiPartFiles,
    getConfigUsagePlatforms,
    saveOutputTemplateByType,
    getOutputTemplateByType,
  })(EnergyTopup)
);
